"use no memo";

import { SplitOrderSchema } from "@repo/validators";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import type { CartItem } from "~/providers/cart-provider";
import type { Order } from "~/providers/order-provider";
import { useCartTable } from "~/hooks/use-cart-table";
import { useOrderManager } from "~/managers/use-order-manager";
import { useCartStore } from "~/stores/use-cart-store";
import ItemsTable from "../cash-register/items-table";
import { Form, FormField, FormItem, useForm } from "../ui/form";

export default function OrderSplitForm({
  order,
  onClose,
}: {
  order: Order;
  onClose: () => void;
}) {
  const { i18n } = useTranslation("common");

  const { splitOrder } = useOrderManager();

  const form = useForm({
    schema: SplitOrderSchema(i18n),
    defaultValues: {
      orderId: order.id,
      orderLines: [],
      tableId: order.tableId,
    },
  });

  const { items } = useCartStore();

  const splitItems = useWatch({ control: form.control, name: "orderLines" });

  const handleSelect = (item: CartItem) => {
    const currentValues = form.getValues("orderLines");
    if (item.parentReference) {
      return;
    }

    const children = order.items
      .filter((i) => i.parentReference === item.reference)
      .map((child) => child.reference);

    if (currentValues.some((i) => i === item.reference)) {
      form.setValue(
        "orderLines",
        currentValues.filter(
          (obj) => obj !== item.reference && obj !== item.parentReference,
        ),
      );

      // children.forEach((child) => {
      //   removeTransferItem(child);
      // });
    } else {
      form.setValue(
        "orderLines",
        [...currentValues, item.reference].concat(children),
      );

      // children.forEach((child) => {
      //   addTransferItem(child);
      // });
    }
  };

  const { columns } = useCartTable({
    canSelect: true,
    items: items.filter((item) => splitItems.includes(item.reference)),
  });

  const handleSubmit = form.handleSubmit(async (data) => {
    const result = await splitOrder(data);
    if (result === true) {
      onClose();
    }
  });

  return (
    <Form {...form}>
      <form
        onSubmit={handleSubmit}
        id="split-order-form"
        className="flex flex-col gap-2"
      >
        <FormField
          control={form.control}
          name="orderLines"
          render={() => (
            <FormItem>
              <ItemsTable
                items={items}
                onSelect={handleSelect}
                columns={columns}
              />
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
}
